import { render, staticRenderFns } from "./type.vue?vue&type=template&id=79988a2d"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"
import style0 from "./type.vue?vue&type=style&index=0&id=79988a2d&lang=scss"
import style1 from "./type.vue?vue&type=style&index=1&id=79988a2d&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79988a2d')) {
      api.createRecord('79988a2d', component.options)
    } else {
      api.reload('79988a2d', component.options)
    }
    module.hot.accept("./type.vue?vue&type=template&id=79988a2d", function () {
      api.rerender('79988a2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/file/type.vue"
export default component.exports